import React, { Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
const BelowFold = lazy(() => import('./components/BelowFold').then(m => ({
  default: m.BelowFold
})));
export function App() {
  return <div className="min-h-screen bg-navy-900 text-slate-200 font-inter selection:bg-cosmic-500/30 overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={<div className="min-h-[200px]" data-id="element-3" />} data-id="element-2">
        <BelowFold data-id="element-4" />
      </Suspense>
    </div>;
}